import { d as dev } from "../../../../chunks/index4.js";
import { c as getMainAlertContent, b as getMainAlertVisibility } from "../../../../chunks/db.js";
const csr = dev;
async function load() {
  const alertContent = await getMainAlertContent();
  const alertVisibility = await getMainAlertVisibility();
  return {
    alert: {
      content: alertContent,
      visible: alertVisibility
    }
  };
}
export {
  csr,
  load
};
//# sourceMappingURL=_page.server.ts.js.map
